import { UpdateStatusWithComment }
	from './transportation_requests/update_status_with_comment';

import Offers from './transportation_requests/offers';

import OfferByManager from './transportation_requests/offer_by_manager';
import AssignToAutocomplete
	from './transportation_requests/assign_to_autocomplete';

export default {
	UpdateStatusWithComment,
	Offers,
	OfferByManager,
	AssignToAutocomplete
};
